import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';
import type { AccountSettingsForms } from '../../components/settings/constants';

type SettingsState = {
  formsWithPendingChanges: AccountSettingsForms[];
};

const getInitialState = (): SettingsState => ({
  formsWithPendingChanges: [],
});

export const accountSettingsSlice = createSlice({
  name: 'accountSettings',
  initialState: () => getInitialState(),
  reducers: {
    addFormWithPendingChanges: (
      state: Draft<SettingsState>,
      action: PayloadAction<AccountSettingsForms>,
    ) => {
      if (!state.formsWithPendingChanges.includes(action.payload)) {
        state.formsWithPendingChanges.push(action.payload);
      }
    },
    removeFormWithPendingChanges: (
      state: Draft<SettingsState>,
      action: PayloadAction<AccountSettingsForms>,
    ) => {
      state.formsWithPendingChanges = state.formsWithPendingChanges.filter(
        (form) => form !== action.payload,
      );
    },
    clearFormsWithPendingChanges: (state: Draft<SettingsState>): void => {
      state.formsWithPendingChanges = [];
    },
  },
});

export const {
  addFormWithPendingChanges,
  removeFormWithPendingChanges,
  clearFormsWithPendingChanges,
} = accountSettingsSlice.actions;
